export const FLUCTUATION_CALLOUT_CLASSNAME = 'bingads-fluctuation-callout';

export const ActionSubPanel = {
  None: 'none',
  FeedbackPanel: 'feedback',
  DismissPanel: 'dismiss',
  /**
   * The state for feedback submitted. Not a real sub panel.
   */
  FeedbackComplete: 'feedback-complete',
};
